import { IOtherField } from '../../interfaces/other-field.interface';
import { ISalary, Salary } from '../../entities/salary';
import * as moment from 'moment';
import { Moment } from 'moment';
import { IJobRequirements } from '../../entities/cv';

export interface ITableCandidatesRes {
  count: number;
  pages: number;
  first_100?: Array<{_id: string}>;
  data: ITableCandidate[];
}

export interface ITableCandidateData {
  count: number;
  pages: number;
  first_100?: Array<{_id: string}>;
  candidates: TableCandidate[];
}

export interface ITableCandidate {
  birthday?: string;
  candidate?: {
    current_job_month?: number;
    cv?: {
      job_requirements?: IJobRequirements;
    }
    job?: IOtherField;
    position?: IOtherField;
    salary?: ISalary;
  };
  country?: string;
  first_name?: string;
  last_name?: string;
  id?: number;
  _id?: string;
  status?: string;
  my_favorite?: boolean;
  last_login?: string;
}

export class TableCandidate {
  birthday: Moment;
  age: number;
  job: IOtherField;
  position: IOtherField;
  salary: Salary;
  country: string;
  first_name: string;
  last_name: string;
  id: number;
  _id: string;
  my_favorite: boolean;
  status: number;
  statusName: string;
  last_login: Moment;
  current_job_month: number;
  loginDatesPassed: number;
  formattedLastLogin: string;

  // const dates = (currentTime.getTime() - date.getTime()) / this.dateInMilliseconds;
  constructor( data: ITableCandidate = {} ) {
    data.candidate = data.candidate || {};
    data.candidate.cv = data.candidate.cv || {};
    data.candidate.cv.job_requirements = data.candidate.cv.job_requirements || {};
    data.candidate.cv.job_requirements.salary = data.candidate.cv.job_requirements.salary || {};
    data.candidate.cv.job_requirements.current = data.candidate.cv.job_requirements.current || {};
    this.birthday = moment(data.birthday);
    this.age = moment().diff(this.birthday, 'years');
    this.job = data.candidate.cv.job_requirements.current.job || {};
    this.position = data.candidate.cv.job_requirements.current.position || {};
    this.salary = new Salary(data.candidate.cv.job_requirements.salary);
    this.country = data.country;
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.id = data.id;
    this._id = data._id;
    this.status = Number(data.candidate.cv.job_requirements.status);
    this.statusName = this.getStatusName(this.status);
    this.my_favorite = data.my_favorite || false;
    this.last_login = data.last_login ? moment(data.last_login) : null;
    this.current_job_month = +data.candidate.current_job_month || 0;
    this.loginDatesPassed = moment().diff(this.last_login, 'days');
    this.formattedLastLogin = moment(this.last_login).fromNow();
  }

  get fullname(): string {
    return `${this.first_name} ${this.last_name}`;
  }

  private getStatusName( status: number ) {
    switch ( status ) {
      case 0:
        return 'Actively looking';
      case 1:
        return 'Passively looking';
      case 2:
        return 'Not available';
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./app/core/services/candidate/table-candidate.ts